import React from 'react'
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import constants from '../../config/constants'

const ProgressStyled = styled(Progress)`
  position: fixed !important;
  margin-top: -10px !important;
  z-index: 999 !important;

  div {
    margin-left: -5px;
  }

  .ant-progress-inner {
    border-radius: 0;
    background-color: ${constants.color.lightGrey1} !important;
  }

  .ant-progress-bg {
    height: 5px !important;
  }

  .ant-progress-success-bg, .ant-progress-bg {
    background-color: ${constants.color.green} !important;
  }
`

const ProgressBar = (props) => {
  return (
    <ProgressStyled percent={props.percent} showInfo={false} />
  )
}

ProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
};

export default ProgressBar
